import React, { useEffect, useState } from "react";

export default function FilterModal({ open, onClose,affiliates,setSelectedRole,setSelectedArea,
setSelectedSetor,
selectedArea,
selectedRole,
selectedSetor,
users,
search,
setSeach,
setSelectedProfissional,
selectedProfissional,
activity,
roles_all

 }) {


  const [areas,setAreas] = useState([]);
  const [roles,setRoles] = useState([]);


  useEffect(()=>{
    if(selectedSetor=='all'){
      setAreas([]);
      setSelectedArea('all');
      setSelectedRole('all');


    }
    else{
      let arae = affiliates[0]?.areas?.filter((item2)=>{
        return selectedSetor?.areas?.includes(item2._id);
      });
      console.log(arae);
      setAreas(arae);
      setSelectedArea('all');
      setSelectedRole('all');

    }
  },[selectedSetor]);



  useEffect(()=>{
    if(selectedArea=='all'){
      setSelectedRole('all');
      setRoles([]);


    }
    else{
      let arae = affiliates[0]?.roles?.filter((item2)=>{
        return selectedArea?.roles?.includes(item2._id);
      });
      console.log(arae);
      setRoles(arae);
      setSelectedRole('all');

    }
  },[selectedArea]);

  if (!open) return null;


  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-end" style={{zIndex:100}}>
      {/* Modal */}
      <div className="bg-white w-1/2 h-full rounded-l-2xl p-6 overflow-y-auto shadow-xl flex flex-col">

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold">Filtrar</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl bg-gray-200 flex items-center justify-center text-xl"
          >
            ✕
          </button>
        </div>

        {/* ----------- Setores ----------- */}
        <div className="border-b pb-6 mb-6">
          <label className="font-semibold text-gray-700">Setores:</label>

          <div className="flex justify-between">
          <p className="text-lg mt-3 text-gray-800">{selectedSetor=='all'?'Todos':selectedSetor?.name}</p>

            <div className="flex items-center gap-3 mt-2">

            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg"
              onClick={(e)=>{
                if(selectedSetor=='all' || affiliates[0]?.sectors?.length==0){
                  return;
                }
                else{
                  if(selectedSetor.index==0){
                    setSelectedSetor('all');
                  }
                  else{
                    let actual:any = {...affiliates[0]?.sectors[selectedSetor.index-1]};
                    actual.index=selectedSetor.index-1;
                    setSelectedSetor(actual)
                  }
                }
              }}
            >
              &lt;
            </button>

            <span className="border rounded-lg px-6 py-2 text-gray-700">
              {selectedSetor=='all'?'01':(selectedSetor.index+2<10?('0'+(selectedSetor.index+2)):(selectedSetor.index+2))}/{(affiliates[0]?.sectors?.length+1)<10?('0'+(affiliates[0]?.sectors?.length+1)):(affiliates[0]?.sectors?.length+1)}
            </span>

            <button onClick={(e)=>{
              console.log(selectedSetor)
                if(selectedSetor=='all'){
                 let actual :any= {...affiliates[0]?.sectors[0]}
                 actual.index=0;
                 setSelectedSetor(actual);
                }
                else{
                  if(selectedSetor.index>=affiliates[0]?.sectors?.length-1){
                    // setSelectedSetor('all');
                    return;
                  }
                  else{
                    let actual:any = {...affiliates[0]?.sectors[selectedSetor.index+1]};
                    actual.index=selectedSetor.index+1;
                    setSelectedSetor(actual)
                  }
                }
              }} className="bg-blue-600 text-white px-4 py-2 rounded-lg">
              &gt;
            </button>
            </div>


          </div>

        </div>

        {/* ----------- Áreas ----------- */}
         <div className="border-b pb-6 mb-6">
          <label className="font-semibold text-gray-700">Áreas:</label>

          <div className="flex justify-between">
          <p className="text-lg mt-3 text-gray-800">{selectedArea=='all'?'Todos':selectedArea?.name}</p>

            <div className="flex items-center gap-3 mt-2">

            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg"
              onClick={(e)=>{
                if(selectedArea=='all' || selectedSetor=='all'){
                  return;
                }
                else{
                  if(selectedArea.index==0){
                    setSelectedArea('all');
                  }
                  else{
                    let actual:any = {...areas[selectedArea.index-1]};
                    actual.index=selectedArea.index-1;
                    setSelectedArea(actual)
                  }
                }
              }}
            >
              &lt;
            </button>

            <span className="border rounded-lg px-6 py-2 text-gray-700">
              {selectedArea=='all'?'01':(selectedArea.index+2<10?('0'+(selectedArea.index+2)):(selectedArea.index+2))}/{(areas?.length+1)<10?('0'+(areas?.length+1)):(areas?.length+1)}
            </span>

            <button onClick={(e)=>{
              console.log(selectedArea)
              if(selectedSetor=='all' || areas.length==0){
                return;
              }
                if(selectedArea=='all'){
                 let actual :any= {...areas[0]}
                 actual.index=0;
                 setSelectedArea(actual);
                }
                else{
                  if(selectedArea.index>=areas?.length-1){
                    // setSelectedSetor('all');
                    return;
                  }
                  else{
                    let actual:any = {...areas[selectedArea.index+1]};
                    actual.index=selectedArea.index+1;
                    setSelectedArea(actual)
                  }
                }
              }} className="bg-blue-600 text-white px-4 py-2 rounded-lg">
              &gt;
            </button>
            </div>


          </div>

        </div>

        {/* ----------- Perfis ----------- */}
       <div className="border-b pb-6 mb-6">
          <label className="font-semibold text-gray-700">Perfis:</label>

          <div className="flex justify-between">
          <p className="text-lg mt-3 text-gray-800">{selectedRole=='all'?'Todos':selectedRole?.name}</p>

            <div className="flex items-center gap-3 mt-2">

            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg"
              onClick={(e)=>{
                if(selectedArea=='all' || selectedSetor=='all' || selectedRole=='all'){
                  return;
                }
                else{
                  if(selectedRole.index==0){
                    setSelectedRole('all');
                  }
                  else{
                    let actual:any = {...roles[selectedRole.index-1]};
                    actual.index=selectedRole.index-1;
                    setSelectedRole(actual)
                  }
                }
              }}
            >
              &lt;
            </button>

            <span className="border rounded-lg px-6 py-2 text-gray-700">
              {selectedRole=='all'?'01':(selectedRole.index+2<10?('0'+(selectedRole.index+2)):(selectedRole.index+2))}/{(roles?.length+1)<10?('0'+(roles?.length+1)):(roles?.length+1)}
            </span>

            <button onClick={(e)=>{
              console.log(roles)
              if(selectedSetor=='all' || selectedArea=='all' || roles.length==0){
                return;
              }
                if(selectedRole=='all'){
                 let actual :any= {...roles[0]}
                 actual.index=0;
                 setSelectedRole(actual);
                }
                else{
                  if(selectedRole.index>=roles?.length-1){
                    // setSelectedSetor('all');
                    return;
                  }
                  else{
                    let actual:any = {...roles[selectedRole.index+1]};
                    actual.index=selectedRole.index+1;
                    setSelectedRole(actual)
                  }
                }
              }} className="bg-blue-600 text-white px-4 py-2 rounded-lg">
              &gt;
            </button>
            </div>


          </div>

        </div>

        {/* Search */}
        <input
          type="text"
          value={search}
          onChange={(e)=>setSeach(e.target.value)}
          placeholder="pesquise pelo nome"
          className="w-full border px-4 py-3 rounded-xl text-gray-700 mb-6"
        />

        {/* ----------- Lista de profissionais ----------- */}
        <div className="space-y-6">
          {users.filter((item)=>item.name.includes(search)).filter((item:any)=>{
            if(selectedSetor=='all') return true;
            if(selectedArea=='all') return item.sector==selectedSetor?.id;
            if(selectedRole=='all') return item.sector==selectedSetor?.id && item.area==selectedArea?.id;
            else return item.sector==selectedSetor?.id && item.area==selectedArea?.id && (item.role==selectedRole?.id || item.role==selectedRole?.name);


          }).filter((item2:any)=>{
            return activity?.appointment?.userPoolWhoShare?.users?.includes(item2._id);
          }).map((p) => (
            <label
              key={p._id}
              className="flex items-center gap-4 py-4 border-b cursor-pointer"
            >
              <input
                type="radio"
                checked={selectedProfissional === p._id}
                onChange={() => setSelectedProfissional(p._id)}
                className="h-5 w-5"
              />

              <img src={p.photoUrl || 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} alt="" className="w-12 h-12 rounded-lg object-cover" />

              <div>
                <p className="font-medium">{p.name}</p>
                <p className="text-gray-500 text-sm">{roles_all.filter((item)=>item._id==p.role || item.name==p.role)[0]?.name}</p>
              </div>
            </label>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-auto pt-8 flex justify-between">
          <button
            onClick={onClose}
            className="border rounded-xl px-8 py-3 text-lg font-medium text-gray-600 bg-gray-100"
          >
            Voltar
          </button>

          {/* <button className="bg-blue-600 text-white rounded-xl px-10 py-3 text-lg font-semibold">
            Filtrar
          </button> */}
        </div>

      </div>
    </div>
  );
}
